import React from "react"

// import { Alert } from "react-bootstrap"

import { BrowserRouter as Router, Switch, Route } from "react-router-dom"

import ProtectedRoute from "./components/ProtectedRoute"

import MyNav from "./components/MyNav"

import Login from "./components/Login"

import Orders from "./components/Orders"
import OrderNew from "./components/OrderNew"
import Order from "./components/Order"

import Dealers from "./components/Dealers"
import Dealer from "./components/Dealer"

import Users from "./components/Users"
import User from "./components/User"

import ProductReturns from "./components/ProductReturns"
import ProductReturn from "./components/ProductReturn"

import Expenses from "./components/Expenses"
import Expense from "./components/Expense"

export default () =>
<Router>
  <div>
    <MyNav />

    <Switch>
      <Route exact path="/" component={Login} />
      <Route path="/login" component={Login} />
      
      <ProtectedRoute path="/orders" component={Orders} />
      <ProtectedRoute path="/order_new" component={OrderNew} />
      <ProtectedRoute path="/order/:id" component={Order} />

      <ProtectedRoute path="/dealers" component={Dealers} />
      <ProtectedRoute path="/dealer/:id" component={Dealer} />

      <ProtectedRoute path="/users" component={Users} />
      <ProtectedRoute path="/user/:id" component={User} />

      <ProtectedRoute path="/returns" component={ProductReturns} />
      <ProtectedRoute path="/return/:id" component={ProductReturn} />

      <ProtectedRoute path="/expenses" component={Expenses} />
      <ProtectedRoute path="/expense/:id" component={Expense} />
    </Switch>
  </div>
</Router>



// WEBPACK FOOTER //
// ./src/App.js